import BaseLayer from "./BaseLayer";
import BoxFrame from "../entities/BoxFrame";

export default class TopLayer extends BaseLayer {
  static instance: TopLayer;
  constructor() {
    super();
    if (!TopLayer.instance) {
      TopLayer.instance = this;
    }
    new BoxFrame();
  }

  static getInstance(): TopLayer {
    return TopLayer.instance;
  }
}